import {
  BASE_LIGHT_MULTIPLIER,
  MODE_DRAGGING_ITEM,
  POINT_CAMERA_FAR,
  POINT_CAMERA_NEAR,
  POINT_SHADOW_BIAS,
  SHADOW_MAP_SIZE,
} from '@constants'
import { ThreeEvent } from '@react-three/fiber'
import { useAppStore } from '@store'
import { LightProps } from '@types'
import { generateSceneLight } from '@utils/sceneObjects/lights/generateSceneLight'
import { useMemo } from 'react'
import { PointLight } from 'three'
import { LightPivot } from '../../ViewerManager/LightPivot'

export function PointLight3D({ id, x, z, textures, color, matrix, catalogID }: LightProps) {
  const { castShadow, distance } = textures
  const select = useAppStore.use.select()
  const mode = useAppStore.use.mode()

  const preGLB = useAppStore.use.sceneGLB().get(catalogID)
  const unselect = useAppStore.use.unselectAll()
  const setMode = useAppStore.use.setMode()
  const isSelected = useAppStore((store) => store.layers[store.currentLayer].selected.has(id))
  const light = useAppStore.use.items().get(id)
  const intensity = light?.intensity
  const pointlight = useMemo(() => new PointLight(), [])

  function handleClick(e: ThreeEvent<MouseEvent>) {
    e.stopPropagation()

    if (isSelected) void unselect()

    select(id, false)

    if (mode === MODE_DRAGGING_ITEM) {
      // setMode('MODE_IDLE')
    }
  }
  const calcIntensity = ((intensity * 30) / 100) * BASE_LIGHT_MULTIPLIER
  
  return (
    <LightPivot
      pivotKey={`${x}-${z}-${id}-`}
      id={id}
      matrix={matrix}
    >
      <primitive
        object={pointlight}
        name={id}
        color={color}
        intensity={calcIntensity}
        castShadow={castShadow.value}
        distance={distance.value}
        shadow-mapSize={SHADOW_MAP_SIZE}
        shadow-camera-far={POINT_CAMERA_FAR}
        shadow-camera-near={POINT_CAMERA_NEAR}
        shadow-bias={POINT_SHADOW_BIAS}
      />
      <group
        onClick={handleClick}
        castShadow={false}
        receiveShadow={false}
        scale={1000}
      >
        {generateSceneLight(preGLB?.glb.scene)}
      </group>
    </LightPivot>
  )
}
